import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignOutAlt } from '@fortawesome/free-solid-svg-icons';

export default function AutoLoginConfirmModal({ name, onConfirm, onCancel, error }) {
  return (
    <div
      style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', zIndex: 1060, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="auto-login-modal-title"
      aria-describedby="auto-login-modal-desc"
    >
      <div style={{ background: '#fff', borderRadius: '10px', padding: '32px 28px', maxWidth: '380px', width: '90%', boxShadow: '0 8px 32px rgba(0,0,0,0.18)' }}>
        <div style={{ width: 48, height: 48, borderRadius: '50%', background: '#e6f2ee', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px' }}>
          <FontAwesomeIcon icon={faSignOutAlt} size="lg" color="#00573C" />
        </div>
        <h4 id="auto-login-modal-title" style={{ textAlign: 'center', fontSize: 17, fontWeight: 700, color: '#2c2c2c', margin: '0 0 8px' }}>Log in as participant?</h4>
        <p id="auto-login-modal-desc" style={{ textAlign: 'center', fontSize: 13, color: '#666', margin: '0 0 16px' }}>
          This opens a new tab signed in as <strong style={{ color: '#333' }}>{name}</strong>.
        </p>
        {error && (
          <div className="alert alert-danger py-2 text-center" style={{ fontSize: 13, marginBottom: 16 }}>
            {error}
          </div>
        )}
        <div style={{ display: 'flex', gap: 12 }}>
          <button
            type="button"
            className="btn btn-outline-secondary"
            style={{ flex: 1 }}
            onClick={onCancel}
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn"
            style={{ flex: 1, background: '#D9A128', color: '#fff', fontWeight: 600, border: 'none' }}
            onClick={onConfirm}
          >
            Log in
          </button>
        </div>
      </div>
    </div>
  );
}
